(() => {
  if (window.__mnQuickBuyBound) return;
  window.__mnQuickBuyBound = true;

  document.addEventListener('click', async (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-mn-quick-buy]') : null;
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    if (link.dataset.busy === 'true') return;

    const variantId = Number(link.dataset.variantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) {
      window.location.assign(link.href);
      return;
    }

    link.dataset.busy = 'true';
    link.setAttribute('aria-busy', 'true');
    link.style.pointerEvents = 'none';

    try {
      const response = await fetch(link.dataset.cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('Cart add failed');
      window.location.assign('/checkout');
    } catch {
      link.dataset.busy = 'false';
      link.removeAttribute('aria-busy');
      link.style.pointerEvents = '';
      window.location.assign(link.href);
    }
  });
})();